module.exports = __webpack_public_path__ + "dist/img/shop.cde616f1.jpg";